var e = /* @__PURE__ */ ((r) => (r.MONTH = "month", r.YEAR = "year", r))(e || {});
export {
  e as CALENDAR_VIEW_MODE
};
